import React, { useMemo, useState } from "react";
import { API_BASE } from "@/lib/api";

// Resolve /api/... relative avatar paths to absolute URLs; leave http(s) alone.
export function absAvatar(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${API_BASE}${url.slice(4)}`;
  return url;
}

function initialsFor(name = "") {
  return name.trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "?";
}

/**
 * Avatar — image with initials fallback for missing/broken URLs.
 * Sizes: 'sm' 32, 'md' 40, 'lg' 56, 'xl' 80.
 */
export default function Avatar({ src, name = "", size = "lg", className = "", testid }) {
  const px = { sm: 32, md: 40, lg: 56, xl: 80 }[size] || 56;
  const [failed, setFailed] = useState(false);
  const url = useMemo(() => absAvatar(src), [src]);
  const showFallback = !url || failed;
  return (
    <div
      data-testid={testid}
      style={{ width: px, height: px, fontSize: Math.round(px * 0.36) }}
      className={`rounded-full overflow-hidden border border-zinc-200 bg-zinc-900 text-white grid place-items-center font-heading font-bold shrink-0 ${className}`}
      aria-label={name || "avatar"}
      title={name}
    >
      {!showFallback && url ? (
        <img
          src={url}
          alt={name}
          onError={() => setFailed(true)}
          className="w-full h-full object-cover"
        />
      ) : (
        <span>{initialsFor(name)}</span>
      )}
    </div>
  );
}
